export default __webpack_public_path__ + "static/8-de311dc8160b0779295c24ef5d89003e.png";